import { render, staticRenderFns } from "./QueryPreview.vue?vue&type=template&id=15ec5c66&scoped=true&"
import script from "./QueryPreview.vue?vue&type=script&lang=js&"
export * from "./QueryPreview.vue?vue&type=script&lang=js&"
import style0 from "./QueryPreview.vue?vue&type=style&index=0&id=15ec5c66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ec5c66",
  null
  
)

export default component.exports